import {RootState} from '@/store/index';
import {ActionContext, ActionTree} from 'vuex';
import {MessageState} from '@/store/modules/message/index';
import MockData from '@/globals/mock.json';

export const actions: ActionTree<MessageState, RootState> = {

  getMessages: (
    {commit, dispatch, state}: ActionContext<MessageState, RootState>,
  ) => {
    const messages = MockData.messages;
    const employees = MockData.employeesList;
  },

};
